import { render, staticRenderFns } from "./UpImage.vue?vue&type=template&id=16b9b5ac&"
import script from "./UpImage.vue?vue&type=script&lang=js&"
export * from "./UpImage.vue?vue&type=script&lang=js&"
import style0 from "./UpImage.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports